module.exports = __webpack_public_path__ + "media/images/demo/horizontal-menu-light-d325780d46ce5ad017310e23713e1997.jpg";